import {
  useReactTable,
  getPaginationRowModel,
  getCoreRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { useContext, useState } from "react";
import { WithdrawContext } from "../../../../../../app/contexts/WithdrawContext";
import { ColumnDefinitionSellerCommission } from "../ColumDefinitionSellerCommission";
import { useAuth } from "@/app/hooks/useAuth";

export const useSellerCommissionTableController = () => {
  const { withdraw, setSkip } = useContext(WithdrawContext);
  const { data, isFetching, isLoading } = withdraw;
  const { isSuperAdmin } = useAuth();

  const { columnsSellerCommissions, handleProofClick, ErrorWithdrawModal } =
    ColumnDefinitionSellerCommission();

  const filteredData = data?.withdraws ? data?.withdraws : [];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const table = useReactTable({
    data: filteredData || [],
    columns: columnsSellerCommissions,
    getPaginationRowModel: getPaginationRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const getPageIndex = () => {
    if (!data) return 0;
    return Math.floor(data.pagination.skip / data.pagination.limit) + 1;
  };

  const getPageCount = () => {
    if (!data) return 0;
    return Math.ceil(data.pagination.total / data.pagination.limit);
  };

  const handleNextPage = () => {
    if (!data) return;
    const newPage = data.pagination.skip / data.pagination.limit + 1;
    if (getPageCount() === getPageIndex()) return;
    const skipValue = newPage * data.pagination.limit;
    setSkip(skipValue);
  };

  const handlePreviousPage = () => {
    if (!data) return;
    const newPage = data.pagination.skip / data.pagination.limit - 1;
    if (newPage < 0) return;
    const skipValue = newPage * data.pagination.limit;
    setSkip(skipValue);
  };
  return {
    isFetching,
    isLoading,
    table,
    handleNextPage,
    handlePreviousPage,
    getPageIndex,
    getPageCount,
    ErrorWithdrawModal,
    isSuperAdmin,
    isModalOpen,
    setIsModalOpen,
    handleProofClick,
  };
};
